import {Card, Container, styled} from '@mui/material';

export const StyledCard = styled(Card)`
	max-width: 852px;
	padding: 24px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-items: center;
	gap: 16px;
	margin: 0 auto;

	${({theme}) => theme.breakpoints.up('sm')} {
		flex-direction: row;
	}
`;

export const StyledContainer = styled(Container)`
	padding: 16px;
	margin-bottom: 56px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 32px;
	}
`;

export const StyledImage = styled('div')`
	margin: 0 auto;

	img {
		width: 280px;
	}

	${({theme}) => theme.breakpoints.up('lg')} {
		img {
			width: 360px;
		}
	}
`;
